import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { RequestFindAvailability } from 'src/app/core/models/request-find-availability';
import { CompanyParamsService } from '../../core/services/company-params.service';
import { DataService } from './data.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  requestFindAvailability: any = {};
  private readonly SEARCH_ROOT_ROUTE: string = 'search';
  constructor(
    public companyParamsService: CompanyParamsService,
    private dataService: DataService,
    private location: Location
  ) { }
  public getSearchRouteArray(paramsUrl: any): string[] {
    try {
      console.log('req', this.requestFindAvailability);
      const filterSearchDate = this.companyParamsService.getFiltersSearchDate();
      const isCalendar = filterSearchDate?.filterSearchValue.name == 'calendar' ? true : false;


      return [
        paramsUrl.companyName,
        this.SEARCH_ROOT_ROUTE,
        this.requestFindAvailability.adults,
        this.requestFindAvailability.children,
        isCalendar ? this.requestFindAvailability.dateFrom : this.requestFindAvailability.months.toString(),
        isCalendar ? this.requestFindAvailability.dateTo : this.requestFindAvailability.year,
        this.requestFindAvailability.priceFrom,
        this.requestFindAvailability.priceTo,
        //this.requestFindAvailability.type,
        this.requestFindAvailability.cruiseTypes,
        //this.requestFindAvailability.length,
        this.requestFindAvailability.lengths,
        this.requestFindAvailability.boat,
        this.requestFindAvailability.promotions.toString() === ''
          ? '0'
          : this.requestFindAvailability.promotions.toString(),
        this.requestFindAvailability.order,
        this.requestFindAvailability.categories.toString() === ''
          ? '0'
          : this.requestFindAvailability.categories.toString(),
        '0',
        isCalendar ? this.requestFindAvailability.dateFilterMode : ''
      ];
    } catch (error) {
      console.log('SearchService.getSearchRouteArray()');
      console.error(error);
      return [this.SEARCH_ROOT_ROUTE];
    }
  }
  getMonthsInUrl(paramsUrl: any): string {
    return this.isNullOrUndefined(paramsUrl) ||
      this.isNullOrUndefined(paramsUrl.months)
      ? ''
      : paramsUrl.months;
  }
  getRatesInUrl(paramsUrl: any): string {
    return this.isNullOrUndefined(paramsUrl) ||
      this.isNullOrUndefined(paramsUrl.rateType)
      ? ''
      : paramsUrl.rateType;
  }
  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }
  getCategoriesInUrl(paramsUrl: any): string {
    return this.isNullOrUndefined(paramsUrl) ||
      this.isNullOrUndefined(paramsUrl.cruiseCategories)
      ? ''
      : paramsUrl.cruiseCategories;
  }
  getIsCharterOnly(paramsUrl: any): boolean {
    if (paramsUrl.isCharterOnly) {
      return paramsUrl.isCharterOnly === 'charter';
    } else {
      return false;
    }
  }

  convertDateFormat(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const formattedDate = `${day}${month}${year}`;
    return formattedDate;
  }

  formatDate(date: Date): string {
    const options = { month: 'long', day: 'numeric', year: 'numeric' } as Intl.DateTimeFormatOptions;
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }

  genereateDefaultRequest(paramsUrl: any, orderBy: number) {
    const filterSearchDate = this.companyParamsService.getFiltersSearchDate();
    const isCalendar = filterSearchDate?.filterSearchValue.name == 'calendar' ? true : false;
    const today = new Date();
    const todayPlus30 = new Date();
    todayPlus30.setDate(todayPlus30.getDate() + environment.searchConfig.dateWindowDays);
    let monthsInUrl =
      this.getMonthsInUrl(paramsUrl) !== ''
        ? this.getMonthsInUrl(paramsUrl).split(',')
        : [String(today.getMonth() + 1)];
    let ratesInUrl =
      this.getRatesInUrl(paramsUrl) !== ''
        ? this.getRatesInUrl(paramsUrl).split(',')
        : ['0'];
    let categoriesInUrl =
      this.getCategoriesInUrl(paramsUrl) !== ''
        ? this.getCategoriesInUrl(paramsUrl)
        : '0';

    if (isCalendar) {
      this.requestFindAvailability =
      {
        agency: this.companyParamsService.getAgencyCode(),
        code: this.companyParamsService.getCode(),
        dateFilterMode:
          this.isNullOrUndefined(paramsUrl.isRange)
            ? filterSearchDate?.filterSearchValue.name : paramsUrl.isRange,
        dateFrom:
          this.isNullOrUndefined(paramsUrl.dateFrom)
            ? isCalendar ? this.convertDateFormat(this.formatDate(today)) : ''
            : paramsUrl.dateFrom,
        dateTo:
          this.isNullOrUndefined(paramsUrl.dateTo)
            ? isCalendar ? this.convertDateFormat(this.formatDate(todayPlus30)) : ''
            : paramsUrl.dateTo,
        month: today.getMonth() + 1,
        months: monthsInUrl,
        year:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.year)
            ? today.getFullYear().toString()
            : paramsUrl.year,
        adults:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.adults)
            ? (this.isNullOrUndefined(paramsUrl.cruiseName) ? 2 : 0)
            : Number(paramsUrl.adults),
        children:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.children)
            ? 0
            : Number(paramsUrl.children),
        category: 0,
        type:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseType)
            ? 0
            : paramsUrl.cruiseType,
        cruiseTypes:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseType)
            ? 0
            : paramsUrl.cruiseType,
        length:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseLength)
            ? 0
            : paramsUrl.cruiseLength,
        lengths:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseLength)
            ? '0'
            : paramsUrl.cruiseLength,
        promotions: ratesInUrl,
        boat:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseName)
            ? '0'
            : paramsUrl.cruiseName === 'charterOnly' ||
              paramsUrl.cruiseName === 'groupsOnly'
              ? '0'
              : paramsUrl.cruiseName,
        order:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.sortBy)
            ? orderBy
            : Number(paramsUrl.sortBy),
        page: 1,
        amenitiesArray: [],
        categoriesArray: [],
        amenities: '0',
        categories: categoriesInUrl,
        priceFrom:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.pfrom)
            ? 0
            : Number(paramsUrl.pfrom),
        priceTo:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.pto)
            ? environment.searchConfig.priceToDefault
            : Number(paramsUrl.pto),
        charterOnly: this.getValueOfCharterInResultAndForm(paramsUrl),

        groupsOnly: !this.isNullOrUndefined(paramsUrl.cruiseName)
          ? paramsUrl.cruiseName === 'groupsOnly'
          : false,
        jsonGroupType: false,
      }
    } else {
      this.requestFindAvailability = {
        agency: this.companyParamsService.getAgencyCode(),
        code: this.companyParamsService.getCode(),
        dateFilterMode:
        this.isNullOrUndefined(paramsUrl.isRange)
          ? filterSearchDate?.filterSearchValue.name : paramsUrl.isRange,
        month: today.getMonth() + 1,
        months: monthsInUrl,
        year:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.year)
            ? today.getFullYear().toString()
            : paramsUrl.year,
        adults:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.adults)
            ? (this.isNullOrUndefined(paramsUrl.cruiseName) ? 3 : 0)
            : Number(paramsUrl.adults),
        children:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.children)
            ? 0
            : Number(paramsUrl.children),
        category: 0,
        type:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseType)
            ? 0
            : paramsUrl.cruiseType,
        cruiseTypes:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseType)
            ? 0
            : paramsUrl.cruiseType,
        length:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseLength)
            ? 0
            : paramsUrl.cruiseLength,
        promotions: ratesInUrl,
        lengths:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseLength)
            ? '0'
            : paramsUrl.cruiseLength,
        boat:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.cruiseName)
            ? '0'
            : paramsUrl.cruiseName === 'charterOnly' ||
              paramsUrl.cruiseName === 'groupsOnly'
              ? '0'
              : paramsUrl.cruiseName,
        order:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.sortBy)
            ? orderBy
            : Number(paramsUrl.sortBy),
        page: 1,
        amenitiesArray: [],
        categoriesArray: [],
        amenities: '0',
        categories: categoriesInUrl,
        priceFrom:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.pfrom)
            ? 0
            : Number(paramsUrl.pfrom),
        priceTo:
          this.isNullOrUndefined(paramsUrl) ||
            this.isNullOrUndefined(paramsUrl.pto)
            ? environment.searchConfig.priceToDefault
            : Number(paramsUrl.pto),
        charterOnly: this.getValueOfCharterInResultAndForm(paramsUrl),

        groupsOnly: !this.isNullOrUndefined(paramsUrl.cruiseName)
          ? paramsUrl.cruiseName === 'groupsOnly'
          : false,
        jsonGroupType: false,
      }
    };
  }

  getValueOfCharterInResultAndForm(paramsUrl: any) {
    try {
      return (
        this.getIsCharterOnly(paramsUrl) ||
        this.isCharterInCruiseName(paramsUrl)
      );
    } catch (error) {
      return false;
    }
  }
  isCharterInCruiseName(paramsUrl: any): boolean {
    if (paramsUrl.cruiseName) {
      return paramsUrl.cruiseName === 'charterOnly';
    } else {
      return false;
    }
  }

  getRequestFindAvail(): RequestFindAvailability {
    return this.requestFindAvailability;
  }

  // set filters
  setMonth(month: any) {
    this.requestFindAvailability.month = month;
  }
  getMonth() {
    return this.requestFindAvailability.month;
  }

  getYear() {
    return this.requestFindAvailability.year;
  }

  getSelectedMonthValue() {
    const selectedMonthDate =
      this.getMonth() !== 0
        ? this.dataService.generateDateByStringYearAndMonthDate(
          this.getMonth() + ',' + this.getYear()
        )
        : new Date(0);
    return selectedMonthDate;
  }

  setCategory(category: any) {
    this.requestFindAvailability.category = category;
  }

  getCategory() {
    return this.requestFindAvailability.category;
  }

  setCategoriesArray(categories: any[]) {
    this.requestFindAvailability.categoriesArray = categories;
  }

  setCode(code: any) {
    this.requestFindAvailability.code = code;
  }

  setOrder(code: number) {
    this.requestFindAvailability.order = code;
  }

  getOrder() {
    return this.requestFindAvailability.order;
  }

  setAgencyCode(codeAgency: any) {
    this.requestFindAvailability.agency = codeAgency;
  }

  getPromotions(): string[] {
    return this.requestFindAvailability.promotions;
  }

  setAmenitiesArray(amenities: any[]) {
    this.requestFindAvailability.amenitiesArray = amenities;
  }

  setAmenities(amenities: string) {
    this.requestFindAvailability.amenities = amenities;
  }

  setCharterOnly(charterOnly: boolean) {
    this.requestFindAvailability.charterOnly = charterOnly;
  }

  setCharterOnlyWithURlValue() {
    this.requestFindAvailability.charterOnly = this.isCharterOnlyInURl();
  }

  setGroupsOnly(groupsOnly: boolean) {
    this.requestFindAvailability.groupsOnly = groupsOnly;
  }

  setCategories(categories: string) {
    this.requestFindAvailability.categories = categories;
  }

  getCategories() {
    return this.requestFindAvailability.categories === ''
      ? '0'
      : this.requestFindAvailability.categories;
  }

  getCharterOnly() {
    return this.requestFindAvailability.charterOnly;
  }

  setPage(page: any) {
    this.requestFindAvailability.page = page;
  }

  getPage() {
    return this.requestFindAvailability.page;
  }

  setAdults(adults: any) {
    this.requestFindAvailability.adults = Number(adults);
  }

  getAdults() {
    return this.requestFindAvailability.adults;
  }

  setChildren(children: any) {
    this.requestFindAvailability.children = Number(children);
  }

  getChildren() {
    return this.requestFindAvailability.children;
  }

  setPriceFrom(priceFrom: any) {
    this.requestFindAvailability.priceFrom = Number(priceFrom);
  }

  setPriceTo(priceTo: any) {
    this.requestFindAvailability.priceTo = Number(priceTo);
  }

  setCruiseType(cruiseType: any) {
    this.requestFindAvailability.type = cruiseType;
  }

  setCruiseTypes(cruiseTypes: any) {
    this.requestFindAvailability.cruiseTypes = cruiseTypes;
  }

  setTourLength(lenght: any) {
    this.requestFindAvailability.length = Number(lenght);
  }

  setTourLengths(lengths: String) {
    this.requestFindAvailability.lengths = lengths;
  }

  setCruiseName(cruiseName: any) {
    this.requestFindAvailability.boat = cruiseName;
  }

  setPromotion(promotions: any) {
    this.requestFindAvailability.promotions = promotions;
  }

  setMonths(months: string[]) {
    this.requestFindAvailability.months = months;
  }

  getMonths(): string[] {
    try {
      return this.requestFindAvailability.months;
    } catch (error) {
      return [];
    }
  }

  setYear(year: any) {
    this.requestFindAvailability.year = year;
  }

  isCharterOnlyInURl() {
    return this.location.path().split('/')[2] === 'charter';
  }

  getJsonGroupType(): boolean {
    return this.requestFindAvailability.jsonGroupType;
  }

  setJsonGroupType(value: boolean) {
    this.requestFindAvailability.jsonGroupType = value;
  }

  setDateFrom(dateFrom: string) {
    this.requestFindAvailability.dateFrom = dateFrom
  }

  setDateTo(dateTo: string) {
    this.requestFindAvailability.dateTo = dateTo;
  }

  getDateFrom(dateFrom: any) {
    return this.requestFindAvailability.dateFrom = dateFrom;
  }

  getDateTo(dateTo: any) {
    return this.requestFindAvailability.dateTo = dateTo;
  }
}
